<template>
  <content-container :table-row-count="tableData.length">
    <!-- 表格数据 -->
    <el-table v-loading="loading" class="normal-table" :border="true" :scrollbar-always-on="true" :data="tableData" :cell-style="initOperatorColumnStyle">
      <el-table-column align="center" prop="orderDetailNo" label="子订单号" :min-width="130" show-overflow-tooltip />
      <el-table-column align="center" prop="dutyName" label="任务名称" :min-width="120" show-overflow-tooltip />
      <el-table-column align="center" prop="serverName" label="服务主体" :min-width="120" show-overflow-tooltip />
      <el-table-column align="center" prop="receivedAmount" label="个人到账金额" :min-width="120" show-overflow-tooltip />
    </el-table>

    <!-- 底部分页 -->
    <template #footer>
      <el-pagination
        v-model:current-page="params.page"
        v-model:page-size="params.size"
        :page-sizes="[defaultPageSize, 25, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        @size-change="onSizeChange"
        @current-change="onCurrentPageChange"
      />
    </template>
  </content-container>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { initOperatorColumnStyle } from '@vue3/components';
import { ContentContainer, queryFreelancerDistributionRecord } from '@core/main';
import { IFreelancerDistributionRecordItem, IFreelancerDistributionRecordParams } from '@core/main/types';
import { useRoute } from 'vue-router';

defineOptions({ name: 'DistributionRecord' });

const route = useRoute();
const defaultPageSize = 12;
const params = reactive<IFreelancerDistributionRecordParams>({
  page: 1,
  size: defaultPageSize,
  personIdNumber: String(route.query.idNo),
  personBank: String(route.query.payAccount),
});
const loading = ref(false);
const total = ref(0);
const tableData = ref<IFreelancerDistributionRecordItem[]>([]);

async function fetchData() {
  loading.value = true;

  try {
    const { data, total: all } = await queryFreelancerDistributionRecord({ ...params });
    
    tableData.value = data;
    total.value = all;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  loading.value = false;
}

function onSizeChange(size: number) {
  params.size = size;
  params.page = 1;
  fetchData();
}

function onCurrentPageChange(page: number) {
  params.page = page;
  fetchData();
}

fetchData();
</script>
